<template>
  <component :is="layoutComponent">
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { ResearchTopicTemplate } from "~/types/app";

const researchTopicTemplate = useResearchTopicTemplate();

const layoutComponent = computed(() => {
  switch (researchTopicTemplate) {
    case ResearchTopicTemplate.V2:
      return defineAsyncComponent(
        () => import("~/components/templates/v2/ResearchTopicLayout.vue")
      );
    case ResearchTopicTemplate.V1:
    default:
      return defineAsyncComponent(
        () => import("~/components/templates/v1/ResearchTopicLayout.vue")
      );
  }
});
</script>
